import { Component, OnInit, inject } from '@angular/core';
import { FullScreenService } from 'ngx-unificator/services';
import { UserService } from '../../../services/user/user.service';
import { NgClass } from '@angular/common';
import { GameIframeService } from '../../../services/game-iframe.service';

@Component({
    selector: 'app-game-iframe',
    templateUrl: './game-iframe.component.html',
    styleUrls: ['./game-iframe.component.scss'],
    imports: [NgClass]
})
export class GameIframeComponent implements OnInit {
  gameIframe = inject(GameIframeService);
  user = inject(UserService);
  fullScreen = inject(FullScreenService);


  ngOnInit() {}

}
